import { render, staticRenderFns } from "./ShowGenericEditor.vue?vue&type=template&id=b3b6943c"
import script from "./ShowGenericEditor.vue?vue&type=script&lang=ts"
export * from "./ShowGenericEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports